const TransferApplicationStep = {
  PERSONAL_DATA: {
    id: 1,
    label: 'Dados Pessoais',
    description: 'Escolha o processo desejado e preencha com seus dados pessoais'
  },
  DOCUMENTATION: {
    id: 2,
    label: 'Documentações',
    description: 'Anexe os documentos solicitados'
  },
  SUMMARY: {
    id: 3,
    label: 'Resumo',
    description: 'Revise seus dados e envie para análise'
  },
  APPROVING: {
    id: 4,
    label: 'Aprovação',
    description: '',
  }
}

const TransferProcessKind = {
  PUBLIC: 'Inscrição pública',
  CONVOCATION: 'Por convocação',
}

export default {
  TransferApplicationStep,
  TransferProcessKind,
};
